export default __webpack_public_path__ + "static/mobileApp-50216998f5af9029e120431a72220d7b.jpg";